class Configuration {
    static readonly API_ENDPOINT = "http://iva-enod.clinbioinfosspa.es:8080/ga4gh-beacon-v2";
    // static readonly API_ENDPOINT = "http://127.0.0.1:9076/elixirbeacon/v2";
    static readonly LOOKUP_API_ENDPOINT = "http://cellbase.clinbioinfosspa.es/lookupws/api/v1";
}


export default Configuration;
